import React from 'react'

import { NotFoundView, RouteProps } from '@sketch/modules-common'

import useUserProfile from 'modules/user/useUserProfile'

// Local Components
import { PublicProfileHeader } from '../components/PublicProfileHeader'
import { WorkspaceProfileLayout } from '../containers/WorkspaceProfileLayout'
import { ProfileInfo } from '../components/ProfileInfo'

// Local Hooks
import { useGetWorkspaceProfile } from '../hooks/useGetWorkspaceProfile'

interface WorkspaceProfilePublicViewProps
  extends RouteProps<'WORKSPACE_PROFILE'> {}

const WorkspaceProfilePublicView = (props: WorkspaceProfilePublicViewProps) => {
  const { shortUrlName } = props.match.params

  const profileResult = useGetWorkspaceProfile({
    variables: { shortUrlName },
  })

  const { data } = useUserProfile()
  const user = data?.me

  if (profileResult.error) {
    return <NotFoundView />
  }

  const workspaceIdentifier = profileResult.profile?.workspace.identifier
  const isAdmin = profileResult.profile?.workspace.userRole === 'ADMIN'
  const isProfilePublic = profileResult.profile?.isPublic === true
  const showHiddenProfileBanner = isAdmin && !isProfilePublic

  return (
    <div>
      <PublicProfileHeader
        workspaceId={workspaceIdentifier!}
        showHiddenProfileBanner={showHiddenProfileBanner}
        user={user}
      />
      <WorkspaceProfileLayout
        workspaceId={workspaceIdentifier!}
        isProfileEditRoute={false}
        profileResult={profileResult}
        profileInfo={<ProfileInfo profile={profileResult.profile || {}} />}
      />
    </div>
  )
}

export default WorkspaceProfilePublicView
